import { render, staticRenderFns } from "./Introduccion.vue?vue&type=template&id=228ac677&scoped=true&lang=pug&"
import script from "./Introduccion.vue?vue&type=script&lang=js&"
export * from "./Introduccion.vue?vue&type=script&lang=js&"
import style0 from "./Introduccion.vue?vue&type=style&index=0&id=228ac677&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ac677",
  null
  
)

export default component.exports